export var JobExecutionStatus;
(function (JobExecutionStatus) {
    JobExecutionStatus["Pending"] = "pending";
    JobExecutionStatus["Complete"] = "complete";
    JobExecutionStatus["Error"] = "error";
})(JobExecutionStatus || (JobExecutionStatus = {}));
